<template>
  <!-- Renderiza el contenido (slot) solo cuando el elemento entra (o se acerca) al viewport.
       Mientras está oculto, ocupa un placeholder de altura mínima para que el scroll sea correcto
       y el IntersectionObserver pueda detectar cuándo se hace visible. Una vez mostrado, se mantiene
       montado (no se desmonta al alejarse) para no perder estado ni romper el drag&drop. -->
  <div ref="root" :style="rendered ? null : ('min-height:' + minHeight + 'px')">
    <slot v-if="rendered"></slot>
  </div>
</template>

<script>
export default {
  name: "LazyVisible",
  props: {
    // Altura aproximada del elemento colapsado, para el placeholder mientras no se ha renderizado.
    minHeight: { type: Number, default: 40 },
    // Margen para pre-renderizar un poco antes de que sea visible y evitar parpadeos al hacer scroll.
    rootMargin: { type: String, default: "400px 0px" }
  },
  data() {
    return {
      rendered: false,
      observer: null
    };
  },
  mounted() {
    const self = this;
    // Si no hay soporte de IntersectionObserver, renderizamos directamente (sin optimización).
    if (typeof IntersectionObserver === "undefined") {
      self.rendered = true;
      return;
    }
    self.observer = new IntersectionObserver(
      entries => {
        for (let i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) {
            self.rendered = true;
            self.disconnectObserver();
            break;
          }
        }
      },
      { rootMargin: self.rootMargin }
    );
    self.observer.observe(self.$refs.root);
  },
  beforeDestroy() {
    this.disconnectObserver();
  },
  methods: {
    disconnectObserver() {
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }
    }
  }
};
</script>
